var _desc, _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinterest({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "https://www.w3.org/2000/svg",
    xmlnsXlink: "https://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_12061"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Pinterest",
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Pinterest",
    width: 16,
    height: 16,
    fill: "currentColor",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_12061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.02 0.05C4.36 0.34 1.71 2.5 1.6 5.57C1.53 7.45 2.07 8.85 3.85 9.25C4.63 7.88 3.6 7.58 3.44 6.59C2.79 2.54 8.12 -0.23 10.9 2.6C12.83 4.56 11.56 10.59 8.45 9.96C5.47 9.37 9.91 4.57 7.53 3.63C5.6 2.86 4.57 5.97 5.49 7.51C4.95 10.16 3.79 12.67 4.26 16C5.78 14.89 6.29 12.78 6.71 10.58C7.48 11.04 7.88 11.52 8.86 11.6C12.45 11.88 14.46 8.01 13.97 4.44C13.54 1.28 10.38 -0.33 7.02 0.05Z",
    fill: "currentColor",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/Pinterest.3b30c613c386f57be5fea119ce96b788.svg";
export { ForwardRef as ReactComponent };